import { render } from "./PCWorkerDetailsRecords.vue?vue&type=template&id=9f7704e8"
import script from "./PCWorkerDetailsRecords.vue?vue&type=script&lang=js"
export * from "./PCWorkerDetailsRecords.vue?vue&type=script&lang=js"

import "./PCWorkerDetailsRecords.vue?vue&type=style&index=0&id=9f7704e8&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__